const phoneRegex = /^((\+(\d){1,3})|(00(\d){1,3})|0)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/

export default function checkAddressBody(form, buttons) {
    let bad = false
    let body = {
        name: false,
        surname: false,
        phone: false,
        street: false,
        city: false,
        zip: false,

        billing_country: false,
        billing_street: false,
        billing_city: false,
        billing_zip: false,

        company: false,
        ico: false,
    }

    if (form.name.length === 0) {
        body.name = true
        bad = true
    }
    if (form.surname.length === 0) {
        body.surname = true
        bad = true
    }
    if (!phoneRegex.test(form.phone) ) {
        body.phone = true
        bad = true
    }
    if (form.street.length === 0) {
        body.street = true
        bad = true
    }
    if (form.city.length === 0) {
        body.city = true
        bad = true
    }
    if (form.zip.length === 0) {
        body.zip = true
        bad = true
    }

    if (buttons.isCompany) {
        if (form.billing_country.length === 0) {
            body.billing_country = true
            bad = true
        }
        if (form.billing_street.length === 0) {
            body.billing_street = true
            bad = true
        }
        if (form.billing_city.length === 0) {
            body.billing_city = true
            bad = true
        }
        if (form.billing_zip.length === 0) {
            body.billing_zip = true
            bad = true
        }
        if (form.company.length === 0) {
            body.company = true
            bad = true
        }
        if (form.ico.length === 0) {
            body.ico = true
            bad = true
        }
    }

    return {
        bad,
        body
    }
}